import TagService from '@/services/tag-service.js';

const types = {
	TAGS_FETCHING: 'TAGS_FETCHING',
	TAGS_SUCCESS: 'TAGS_SUCCESS',
	TAGS_ERROR: 'TAGS_ERROR',

	TAG_DELETE_FETCHING: 'TAG_DELETE_FETCHING',
	TAG_DELETE_SUCCESS: 'TAG_DELETE_SUCCESS',
	TAG_DELETE_ERROR: 'TAG_DELETE_ERROR',
};

const state = {
	tags: [],
	isFetchingTags: false,
	isDeletingTag: false,
};

const actions = {
	async fetchTags({commit}) {
		commit(types.TAGS_FETCHING);

		try {
			const response = await TagService.getAll();
			
			commit(types.TAGS_SUCCESS, response);

			return response;
		}
		catch (error) {
			commit(types.TAGS_ERROR);

			throw error;
		}
	},

	async deleteTag({commit}, tagId) {
		commit(types.TAG_DELETE_FETCHING);

		try {
			await TagService.delete(tagId);

			commit(types.TAG_DELETE_SUCCESS);
		}
		catch (error) {
			commit(types.TAG_DELETE_ERROR);

			throw error;
		}
	}
};

const mutations = {
    [types.TAGS_FETCHING](state) {
		state.isFetchingTags = true;
	},
	[types.TAGS_SUCCESS](state, payload) {
		state.isFetchingTags = false;
		state.tags = payload;
	},
	[types.TAGS_ERROR](state) {
		state.isFetchingTags = false;
	},

	[types.TAG_DELETE_FETCHING](state) {
		state.isDeletingTag = true;
	},
	[types.TAG_DELETE_SUCCESS](state) {
		state.isDeletingTag = false;
	},
	[types.TAG_DELETE_ERROR](state) {
		state.isDeletingTag = false;
	},
};

const getters = {
	isFetchingTags: state => state.isFetchingTags,
	isDeletingTag: state => state.isDeletingTag,
	tags: state => state.tags,
};

export default {
    state,
    actions,
    mutations,
    getters,
}


// WEBPACK FOOTER //
// ./src/store/modules/tags/index.js